import React, { useEffect, useState } from 'react';
import { Api } from '../../api/Api';
import { Link, useParams } from 'react-router-dom';
import { ServerUrl } from '../../api/ServerUrl';
import FadeInOut from '../../tools/FadeInOut';
import { useLang } from '../../../context/LangContext';

const LandingServicesDetails = () => {

    useEffect(() => {
        document.title = `Foot Balance Technology BD - Services List Details`;
    }, []);

    const { lang } = useLang(); // 🔥 LANGUAGE FROM CONTEXT
    const { http } = Api();
    const { slug } = useParams();
    const httpbackPage = ServerUrl;

    const [singleLayouts, setSingleLayouts] = useState({});
    const [backImage, setBackImage] = useState('');

    useEffect(() => {
        http.get(`get-landing-page-services/${slug}`)
            .then(res => {
                setSingleLayouts(res.data.data);
                setBackImage(res.data.backImage);
            })
            .catch(error => {
                console.error('Error fetching layouts:', error);
            });
    }, [slug]);


    // 🔥 TITLE LANGUAGE SWITCH
    const serviceTitle = lang === "en"
        ? (singleLayouts.title ?? "")
        : (singleLayouts.title_b ?? singleLayouts.title ?? "");

    // 🔥 DESCRIPTION LANGUAGE SWITCH (HTML SUPPORTED)
    const serviceDescription = lang === "en"
        ? (singleLayouts.description ?? "")
        : (singleLayouts.description_b ?? singleLayouts.description ?? "");

    return (
        <div>
            {/* HEADER SECTION */}
            <section
                className="page-title pageTitleBg"
                style={{
                    backgroundImage: `url(${ServerUrl}/backend/img/back_image/${backImage.image})`
                }}
            >
                <div className="auto-container">
                    <h2>{serviceTitle}</h2>

                    <ul className="page-breadcrumb">
                        <li><Link to="/">home</Link></li>
                        <li>Services</li>
                        <li>{serviceTitle}</li>
                    </ul>
                </div>
            </section>

            {/* DETAILS SECTION */}
            <FadeInOut>
                <div className="sidebar-page-container">
                    <div className="auto-container">
                        <div className="row clearfix">

                            <div className="content-side col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <div className="services-detail">

                                    <div className="row inner-box">
                                        <div className="content-column col-lg-12 col-md-8 col-sm-12">

                                            <div className="text-center mt-4">
                                                <img
                                                    src={`${httpbackPage}/backend/img/services/${singleLayouts.image}`}
                                                    className="img-fluid"
                                                    alt={singleLayouts.alt}
                                                    style={{
                                                        width: "250px",
                                                        height: "auto",
                                                        objectFit: "cover"
                                                    }}
                                                />
                                            </div>

                                            <div className="inner-column">
                                                <div
                                                    className="text mb-3"
                                                    style={{ fontSize: "20px", lineHeight: "1.6" }}
                                                    dangerouslySetInnerHTML={{ __html: serviceDescription }}
                                                ></div>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </FadeInOut>
        </div>
    )
}

export default LandingServicesDetails;
